import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ darkMode, setDarkMode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className={`navbar ${darkMode ? 'dark' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M15 2L28 15L15 28L2 15L15 2Z" stroke="#10B981" strokeWidth="2"/>
            <path d="M10 15L15 10L20 15L15 20L10 15Z" fill="#10B981"/>
          </svg>
          <span className="logo-text">CivilCADPro</span>
        </div>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <a href="#home">Home</a>
          <a href="#features">Features</a>
          <a href="#how-it-works">How It Works</a>
          <a href="#demo">Book a Demo</a>
        </div>
        
        <div className="nav-actions">
          <button 
            className="theme-toggle"
            onClick={() => setDarkMode(!darkMode)}
            aria-label="Toggle theme"
          >
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button className="nav-cta">
            <a href="#demo">Book a Demo</a>
          </button>
        </div>
        
        <button 
          className="hamburger"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;